import { MESSAGE_VALUE_NOT_ASSIGNED } from '../config/app-messages'

export const valueStringCheck = (
  value: string | undefined | null,
  invalidValues: string[] = [],
  isInvalidValue = MESSAGE_VALUE_NOT_ASSIGNED
) => {
  if (value && value.length > 0 && value.toLowerCase() !== 'unknown' && !invalidValues.includes(value.toLowerCase())) {
    return value
  }

  return isInvalidValue
}

export const valueIsValidCheck = (value: string | undefined | null, invalidValues: string[] = []) => {
  if (value && value.length > 0 && value.toLowerCase() !== 'unknown' && !invalidValues.includes(value.toLowerCase())) {
    return true
  }

  return false
}
